/***
 * Difhub version: 1.0.0 draft
 * https://difhub.com/view/organizations/Business%20Systems/systems/Settlement/applications/Billing/datasets/EmailDelivery/versions/1
 */
export class EmailDeliveryDto {
  emailType: string; // enum from api
  emailAddresses: string[] = [];

  constructor(d?: EmailDeliveryDto) {
    if (!d) {
      return;
    }
    this.emailType = d.emailType;
    this.emailAddresses = d.emailAddresses || [];
  }
}
